import { Injectable, OnDestroy } from '@angular/core';
import * as moment from 'moment';
import { Subscription, interval } from 'rxjs';
import { AuthFacade } from '../store/auth-state/+state/auth.facade';
import { NavigationService } from './navigation.service';

@Injectable({ providedIn: 'root' })
export class LogoutTimerService implements OnDestroy {
	private readonly STORAGE_KEY = 'lastCheckDate';
	private timerSub?: Subscription;

	constructor(
		private authFacade: AuthFacade,
		private navService: NavigationService
	) {}

	startTimer() {
		this.checkAndSetDate();
		// every 3 hours
		this.timerSub = interval(3 * 60 * 60 * 1000).subscribe(() => {
			this.checkAndSetDate();
		});
	}

	private checkAndSetDate() {
		const today = moment();
		const savedDate = localStorage.getItem(this.STORAGE_KEY);
		console.log('saveDate', savedDate);

		if (!savedDate) {
			localStorage.setItem(this.STORAGE_KEY, today.toISOString());
			return;
		}

		if (today && savedDate && !today.isSame(moment(savedDate), 'day')) {
			localStorage.setItem(this.STORAGE_KEY, today.toISOString());

			this.authFacade.logout();
			this.navService.login();
		}
	}

	stopTimer() {
		if (this.timerSub) {
			this.timerSub.unsubscribe();
			this.timerSub = undefined;
		}
	}

	ngOnDestroy() {
		this.stopTimer();
	}
}
